module.exports = __webpack_public_path__ + "media/04Qu Yuan.e86e63d7.mp3";